import ContactUs from 'components/ContactUs';
import Header from 'components/Header';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { InvoiceService } from 'services/invoice.service';

import { ReactComponent as IconConfirm } from './confirms-icon.svg';

import './MercuryoRedirect.scss';

export const MercuryoRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const invoiceInfoQuery = useQuery(
    ['invoiceInfo', id],
    () =>
      InvoiceService.getInvoiceInfo({
        uuid: id || '',
      }),
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (error: any) => {
        if (error?.response?.status) navigate('/404');
      },

      onSuccess: (data) => {
        if (data?.payment?.status !== 'confirm_check' && data?.payment?.status !== 'check') {
          navigate(`/pay/${id}`);
        }
      },
      refetchInterval: 5000,
    },
  );

  return (
    <>
      <div className='redirect__wrapper'>
        <div className='redirect__container'>
          <div className='redirect__content'>
            <div className='redirect__header'>
              <Header
                brandingData={invoiceInfoQuery.data?.branding}
                isShowP2P={false}
                url_return={invoiceInfoQuery?.data?.payment?.url_return}
              />

              <button className='cancel_btn cancel_btn_disabled'>{t('mercuryo.Cancel paying via fiat')}</button>
            </div>

            <div className='mercuryo__redirect'>
              <div className='confirm__icon_uniq'>
                <IconConfirm />
              </div>

              <p className='redirect__text'>{t('mercuryo.Kindly wait, the payment is being processed')}</p>

              <span className='redirect__description'>
                {t('mercuryo.Please do not reload the page, this may cause the process to be cancelled')}
              </span>
            </div>
          </div>
          <ContactUs />
        </div>
      </div>
    </>
  );
};
